import { IonButton, IonContent, IonHeader, IonInput, IonLabel, IonPage, IonTitle, IonToast, IonToolbar, isPlatform } from '@ionic/react';
import React, { useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { logar, requestService, usuarioCadastrar } from '../../../Utils/Services';
import './NovoLogin.css';

const NovoLogin: React.FC = () => {
  const history = useHistory();
  const campoTelefone = useRef<any>(null);
  const [telefone, setTelefone] = useState("");
  const [desabilitarBotaoContinuar, setDesabilitarBotaoContinuar] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");

  // Utilitários
  const formatarTelefone = (tel: string): string => {
    return "55" + tel.replace(/[\(\)\s\-]/g, "");
  };

  const cadastrar = () => {
    if (desabilitarBotaoContinuar) return; // evita múltiplos cliques

    let validadorCelular = /^((\+?55\ ?[1-9]{2}\ ?)|(\+?55\ ?\([1-9]{2}\)\ ?)|(0[1-9]{2}\ ?)|(\([1-9]{2}\)\ ?)|([1-9]{2}\ ?))((\d{4}\-?\d{4})|(9[1-9]{1}\d{3}\-?\d{4}))$/;

    if (telefone.length !== 15) {
      setTextToast("Preencha seu celular.");
      setShowToast(true);
    }
    else if (!validadorCelular.test(telefone)) {
      setTextToast("Celular Inválido.");
      setShowToast(true);
    }
    else {

      setDesabilitarBotaoContinuar(true);

      const telefoneFormatado = formatarTelefone(telefone);

      const objectRequest = {
        nome: "", // nome,
        cpf: telefoneFormatado, //!isEstrangeiro ? cpf.replace("-", "").replace(".", "").replace(".", "") : documento.padStart(11, '0'),
        telefone: telefoneFormatado,
        email: "",
        dispositivoIos: isPlatform('ios')
      }
      requestService(
        usuarioCadastrar.url,
        {
          method: usuarioCadastrar.method,
          headers: [
            ["token", window.localStorage.getItem("token") || ""]
          ],
          body: JSON.stringify(objectRequest),
          credentials: 'include'
        },
        history,
        (response: any) => {
          console.log(response);
          if (response) {
            console.log("Cadastro realizado com sucesso");
            window.localStorage.setItem("telefone", objectRequest.telefone);
            window.localStorage.setItem("token", "token=" + response.token);
            setDesabilitarBotaoContinuar(false);
            history.push("/validar-celular");
          }
        },
        (error: any) => {
          console.log(error);



          const telefoneFormatado = "55" + telefone.replace("(", "").replace(")", "").replace(" ", "").replace("-", "");

          const objectRequest = {
            cpf: telefoneFormatado, // !isEstrangeiro ? cpf.replace("-", "").replace(".", "").replace(".", "") : documento.padStart(11, '0'),
            telefone: telefoneFormatado,
            dispositivoIos: isPlatform('ios')
          }

          requestService(
            logar.url,
            {
              method: logar.method,
              headers: [
                ["token", window.localStorage.getItem("token")]
              ],
              body: JSON.stringify(objectRequest),
              credentials: 'include'
            },
            history,
            (response: any) => {
              if (response) {
                setTelefone("");

                console.log(response);
                // time difference
                var timeDiff = Math.abs(Date.now() - Date.parse(response.message.dataInicio));
                // days difference
                var diffDays = 90 - (Math.ceil(timeDiff / (1000 * 3600 * 24))); // difference

                console.log(diffDays);
                if (response.message.appPeriodoAvaliacao || response.message.assinaturaAtiva || diffDays >= 0) {
                  console.log('Cliente efetuou pagamento ou esta em período de avaliação');
                  window.localStorage.setItem("telefone", "55" + telefone.replace(/\(/g, "").replace(/\)/g, "").replace(/\ /g, "").replace(/\-/g, ""));
                  window.localStorage.setItem("token", "token=" + response.token);
                  window.localStorage.setItem("nome", response.message.nome);

                  setDesabilitarBotaoContinuar(false);
                  history.push("/validar-login");
                }
              } else if (response.status === 400) {

              }
            },
            (error: any) => {

              //console.log(error)
              setTextToast("Infelizmente não conseguimos efetuar o login com esse celular.");
              setShowToast(true);
              setDesabilitarBotaoContinuar(false);
            }
          )
            .finally(() => {
              // fallback de segurança caso callbacks não desativem
              setDesabilitarBotaoContinuar(false);
            });

        }
      )
      // timeout de segurança (20s)
      setTimeout(() => setDesabilitarBotaoContinuar(prev => prev && false), 20000);
    }

  }

  function onKeyUpTelefone(e: any) {

    e.persist();
    e.preventDefault();

    if (e.target.value.length > 15) {
      e.target.value = e.target.value.substring(0, 15);
      setTelefone(e.target.value.substring(0, 15));
      return;
    }

    console.log(telefone.length);
    console.log(e.target.value.length);

    let replaceAt = function (str: any, index: any, replacement: any) {
      return str.substr(0, index) + replacement + str.substr(index + replacement.length);
    }

    let form = "(__) _____-____";

    let val = e.target.value;

    let i = 1;
    if (telefone.length > 0) {
      i = 0;
    }
    let j = 0;
    let aumentou = false;

    if (val.length > telefone.length) {

      for (; i < form.length; i++) {
        if (j < val.length) {

          form = replaceAt(form, i, val.charAt(j))

          if (form.charAt(i + 1) === '(' || form.charAt(i + 1) === ')' || form.charAt(i + 1) === '-') {
            if (val.charAt(j + 1) !== form.charAt(i + 1)) {
              if (form.charAt(i + 1) === ')') {
                i++;
              }
              i++;
              aumentou = true;
              j++;
            } else {
              j++
            }
          } else {
            j++;
          }
        } else {
          break;
        }
      }
    } else {
      if (telefone.length === 1 || telefone.length === 11) {
        form = val.substr(0, val.length - 1);
      } else if (telefone.length === 5) {
        form = val.substr(0, val.length - 2);
      } else {
        form = val;
      }
      i = form.length;
    }
    setTelefone(form.substr(0, i));
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonTitle>Entrar</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className={"NovoLogin"}>
        <IonLabel className="titulo"><strong>Falta pouco para matar sua fome!</strong></IonLabel>

        <div className="input">
          <span>Informe o número do seu celular</span>
          <IonInput ref={(ref) => campoTelefone.current = ref} type="tel" maxlength={15} placeholder="(__) _____-____" required value={telefone} onKeyUp={onKeyUpTelefone} />
        </div>

        <IonButton onClick={cadastrar} disabled={desabilitarBotaoContinuar}>
          {desabilitarBotaoContinuar ? 'Aguarde...' : 'Continuar'}
        </IonButton>
        <IonLabel hidden={true} className="jaTem">Já tem uma conta? <Link to="/primeiroacesso">Entrar</Link></IonLabel>
        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />
      </IonContent>
    </IonPage>
  );
};

export default NovoLogin;
